import { useLanguage } from '../context/LanguageContext';
import { 
  formatPrice, 
  getCurrencyForLanguage, 
  getCurrencySymbolForLanguage 
} from '../services/currencyService';

export const useCurrency = () => {
  const { language } = useLanguage();
  
  const formatPriceForLanguage = (price, originalCurrency = 'MAD') => {
    return formatPrice(price, language, originalCurrency);
  };
  
  const getCurrentCurrency = () => {
    return getCurrencyForLanguage(language);
  };
  
  const getCurrentCurrencySymbol = () => {
    return getCurrencySymbolForLanguage(language);
  };
  
  return {
    formatPrice: formatPriceForLanguage,
    getCurrency: getCurrentCurrency,
    getCurrencySymbol: getCurrentCurrencySymbol,
    currentLanguage: language
  };
};

export default useCurrency;